import { GetCertificates as UseCasesRemoteGetCertificates } from '~/domain/usecases/deamon/remote';
import { RemoteGetCertificates } from '~/data/repository/deamon';
import { makeDeamonUrl, makeHttpClient } from '../../http';

export const MakeRemoteGetCertificates = (): UseCasesRemoteGetCertificates =>
  new RemoteGetCertificates(makeDeamonUrl('/certificates'), makeHttpClient());
